var React = require('react');
var createReactClass = require('create-react-class');
var marked = require('marked');
var PureRenderMixin = require('react-addons-pure-render-mixin');

var SymptomMarkdown = createReactClass({
  mixins: [PureRenderMixin],

  rawMarkup: function () {
    var rawMarkup = marked(this.props.payload.content.toString());
    return { __html: rawMarkup };
  },

  hasTitle: function () {
    return Boolean(this.props.payload.title);
  },

  render: function () {
    // console.log("MARKDOWN:" + JSON.stringify(this.props));
    return (
      <div>
        {this.hasTitle() ? <strong>{this.props.payload.title}</strong> : null}
        <span dangerouslySetInnerHTML={this.rawMarkup()} />
      </div>
    );
  },
});

module.exports = SymptomMarkdown;



// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/symptomMarkdown.jsx